import React from "react";

const Loading: React.FC<{overCart?: boolean}> = (props) => {
  const { overCart } = props;
  return <div className={overCart ? "loadingMask overCart": "loadingMask"}>
    <div className="body">

    <div className="loadingIcon"></div>
    </div>
    </div>;
}

export default Loading;